import $ from "jquery"

function contactPopupClose(){
    $('.js-contact-form-thank-you-overlay, .js-contact-form-thank-you').hide();
    $('.js-thankyou-popup-overlay, .js-thankyou-popup').hide();
    $('body').removeClass('o-hidden');
}

/**
 * Thank you popup for forms:
 * #1431: Convertion of Thank you Popup to Ajax [Ecommerce]
 */
function thankYouPopup(event){
    let apiResponse = event.detail.apiResponse;
    const apiMessage = apiResponse.message;

    $.ajax({
        url: ajax_admin.ajaxurl,
        method: 'POST',
        data: {
            action: 'thank_you_popup'
        },
        success: function (response) {
            if (response.success && response.data) {
                const $popup = $(response.data);
                $('body').append($popup);
                $('body').addClass('o-hidden');

                $(".js-thank-you-popup-header-text").text(apiMessage);

                // Cleanup any existing popup/overlay (avoid duplicates)
                $('.js-contact-popup-form').hide().remove();
                $('.js-contact-popup-overlay').hide().remove();

                $('.js-thankyou-popup-overlay, .js-thankyou-popup-close').on('click', function(){
                    contactPopupClose();
                });

                $(document).on('keyup', function(e) {
                    if (e.key === "Escape") {
                        contactPopupClose();
                    }
                });
            }
        }
    });
}

/**
 * Task #1392:#1392: [Front] [eCommerce] Contact page
 * https://todo.createit.com/my-work?modal=Task-160507-1213
 */
function contactFormThankYou(){
    $.ajax({
        url: ajax_admin.ajaxurl,
        method: 'POST',
        data: {
            action: 'thank_you_contact_form'
        },
        success: function (response) {
            if (response.success && response.data) {
                const $popup = $(response.data);
                $('body').append($popup);
                $('body').addClass('o-hidden');

                $('.js-contact-form-thank-you-overlay, .js-contact-form-thank-you-close').on('click', function(){
                    contactPopupClose();
                });

                $(document).on('keyup', function(e) {
                    if (e.key === "Escape") {
                        contactPopupClose();
                    }
                });
            }
        }
    });
}

document.addEventListener('wpcf7mailsent', function(event) {
    let apiResponse = event.detail.apiResponse;
    const apiMessage = apiResponse.message;
    
    if(apiMessage == 'eCommerce Contact Form Sent'){
        contactFormThankYou();
    } else if ( apiMessage == 'eCommerce Newsletter Form Sent' || apiMessage == 'Cart Abandonment Rate Form Sent' ) {
        // console.log('do nothing');
    } else {
        thankYouPopup(event);
    }
}, false);

// Testing
// contactFormThankYou();